import type React from 'react';

import { Avatar, Link, Separator, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useEmailDecisionMakerModalBody } from './hooks/useEmailDecisionMakerModalBody';

export const EmailDecisionMakerModalBody: React.FC = () => {
	const {
		data: { decisionMakers },
		actions: { handleEmailClick },
	} = useEmailDecisionMakerModalBody();

	return (
		<ul className="pt-6">
			{decisionMakers.map((dm, index) => (
				<li key={dm.id}>
					<div className="flex flex-row">
						<Avatar
							data-testid="dm-image"
							src={dm.photo?.userMedium.url}
							className="mr-2.5 shrink-0"
							size={50}
							alt=""
						/>
						<div className="flex flex-col">
							<Text as="p" variant="body" size="large" fontWeight="bold" truncate>
								{dm.displayName}
							</Text>

							{dm.title && (
								<Text size="small" className="wrap-break-word break-keep">
									{dm.title}
								</Text>
							)}
						</div>
						{dm.emailHref && (
							<div className="ml-auto pl-4">
								<Link
									className="w-max"
									href={dm.emailHref}
									target="_blank"
									variant="primary"
									size="small"
									onClick={handleEmailClick}
								>
									<Translate value="corgi.petition.starter_dashboard.notifications.email_decision_maker.modal_send_email_link" />
								</Link>
							</div>
						)}
					</div>
					{index !== decisionMakers.length - 1 && <Separator role="presentation" className="my-5" />}
				</li>
			))}
		</ul>
	);
};
